import { render, staticRenderFns } from "./transitionExpand.vue?vue&type=template&id=893b47be&"
import script from "./transitionExpand.vue?vue&type=script&lang=js&"
export * from "./transitionExpand.vue?vue&type=script&lang=js&"
import style0 from "./transitionExpand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports